export default "__VITE_ASSET__2f41f606__"